import { Component } from '@angular/core';

@Component({
  selector: 'ngx-formations',
  template: `<router-outlet></router-outlet>`,
})
export class FormationsComponent {
}
